import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_DETECTED_BY_FILTER,
  SORTING_CHANGE,
} from './constants'

const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

const generalFilterChange = (value) => ({
  type: GENERAL_FILTER_CHANGE,
  payload: { value },
})

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const dateFilterChange = (value) => ({
  type: DATE_FILTER_CHANGE,
  payload: { value },
})

const setDetectedByFilter = (values) => ({
  type: SET_DETECTED_BY_FILTER,
  payload: { values },
})

const sortingChange = (sortingBy, sortingDirection) => ({
  type: SORTING_CHANGE,
  payload: { sortingBy, sortingDirection },
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  searchChange,
  searchReset,
  paginateChange,
  generalFilterChange,
  dateFilterChange,
  setDetectedByFilter,
  sortingChange,
}
